import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useSearchResultsEventListener } from '../../hooks/useSearchResultsEventListener'
import { configurationData } from '../../redux/reducers/configuration'
import { fetchConfiguration } from '../../redux/actions/fetchConfiguration'

import ErrorBoundary from '../../components/elements/ErrorBoundary'
import LoadingSpinner from '../../components/elements/LoadingSpinner'
import ResultsContainer from '../views/ResultsContainer'

import { initializeAlgolia } from '../../utilities/algolia/algolia'

initializeAlgolia()

function App() {
  useSearchResultsEventListener()
  const configuration = useSelector(state => configurationData(state))
  const dispatch = useDispatch()

  useEffect(() => {
    // doing it this way rather then only on load to prevent having to wait when using hot reload.
    if (!configuration.data && !configuration.loading && !configuration.error) {
      dispatch(fetchConfiguration())
    }
  }, [dispatch, configuration])

  return (
    <div className="app__base" data-testid="app__base">
      {configuration.loading ? (
        <LoadingSpinner />
      ) : configuration.error ? (
        <ErrorBoundary errorMessage={configuration.error} />
      ) : (
        <ResultsContainer />
      )}
    </div>
  )
}

export default App
